import { space4, space8 } from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const StyledInputOTPStep = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space8};

  span {
    cursor: pointer;
  }

  & > form {
    margin-top: ${space8};
    display: flex;
    flex-direction: column;
    gap: ${space4};
  }
`;
